import React, {Component} from 'react';
import {connect} from 'react-redux';
import Alert from 'react-s-alert';

import '../../assets/css/rheostat.css';

import {Button, Row, Col, Tooltip, Card, CardBody, CardHeader, FormGroup, Label, Input} from "reactstrap";
import Rheostat from "rheostat";
import {setMinLeaseMonth, setMaxLeaseMonth, setTenantPrefBath, setTenantPrefBed, setTenantPrefRent} from "../tenant/actions/tenant";
import PolyUtil from "../../util/PolyUtil";
import store from 'store';
import PreferenceStreetMap from "../../components/media/maps/PreferenceStreetMap";
import {handleUpdateListingPreferences} from "../tenant/actions/roommates";
import Loader from "../../components/display/Loader";

class TenantGroupPreferences extends Component {
    state = {
        listing_preferences: {},
        modified: false,
        showHelpTooltip: false,
        isUpdating: false
    };

    componentWillMount() {
        this.setState({listing_preferences: this.props.listing_preferences});
    }

    setModified() {
        this.setState({modified: true});
    }

    updateLocationPreferences(prefs) {
        this.setState({isUpdating: true});

        this.props.handleSavePreferences(Object.assign({}, {
            desired_location_latitude: prefs.lat,
            desired_location_longitude: prefs.lng,
            desired_location_radius: prefs.radius //change to desired_location_radius, remove rounding
        })).then(() => {
            this.setState({isUpdating: false});
        });
    }

    content = () => {

    };

    render() {
        const {handleUpdateRent, handleUpdateBed, handleUpdateBath, handleSavePreferences, listing_preferences, is_coordinator, handleUpdateMinLeaseStart, handleUpdateMaxLeaseStart} = this.props;
        if (!PolyUtil.objEmpty(listing_preferences)) {
            const {min_rent, max_rent, min_bedrooms, max_bedrooms, min_bathrooms, max_bathrooms, min_lease_start_month, max_lease_start_month} = listing_preferences;

            // console.log("Min rent: ", listing_preferences);

            const _min_rent = (parseInt(min_rent, 10) > 10000 ? 10000 : parseInt(min_rent, 10));
            const _max_rent = (parseInt(max_rent, 10) > 10000 ? 10000 : parseInt(max_rent, 10));
            const _min_bedrooms = Math.max(min_bedrooms, 1);
            const _max_bedrooms = Math.min(max_bedrooms, 10);
            const _min_bathrooms = Math.max(min_bathrooms, 1);
            const _max_bathrooms = Math.min(max_bathrooms, 10);

            let snapPoints = [];
            for (let i = 50; i <= 20000; i += 25) {
                snapPoints.push(i);
            }

            if (store.get('type') === 'tenant') return (
                <Card className="pr-card">
                    <CardHeader tag="h4">Listing Recommendation Preferences</CardHeader>
                    <CardBody>
                        {!is_coordinator ? <p className="text-warning">You're not the group coordinator. That means you aren't currently able to edit preferences for your group.</p> : null}
                        <div>
                            <Row>
                                <Col sm={12} md={6} className="my-2">
                                    <PreferenceStreetMap
                                        control={true}
                                        lat={listing_preferences.desired_location_latitude}
                                        lng={listing_preferences.desired_location_longitude}
                                        radius={listing_preferences.desired_location_radius}
                                        style={{paddingBottom: "66.66%"}}
                                        onUpdate={(dat) => this.updateLocationPreferences(dat)}
                                        is_coordinator={is_coordinator}
                                        className="rounded-top"/>
                                </Col>
                                <Col sm={12} md={6} className="my-2">
                                    <div className="top-bar-title">
                                        <p>Recommendation Criteria <i className="fa fa-info-circle" id="info_tooltip"/></p>
                                    </div>
                                    <div className="top-bar-slider m-2">
                                        <p>
                                            <small>
                                                <i className="fa fa-usd"/>
                                                {' ' + _min_rent + ' - ' + _max_rent}
                                            </small>
                                        </p>

                                        <Rheostat
                                            min={50}
                                            max={10000}
                                            snap={true}
                                            snapPoints={snapPoints}
                                            values={[_min_rent, _max_rent]}
                                            disabled={!is_coordinator}
                                            onValuesUpdated={(value) => {
                                                handleUpdateRent(value);
                                                this.setModified();
                                            }}/>
                                    </div>
                                    <div className="top-bar-slider m-2">
                                        <p>
                                            <small>
                                                <i className="fa fa-bed"/>
                                                {' ' + _min_bedrooms + ' - ' + _max_bedrooms}
                                            </small>
                                        </p>

                                        <Rheostat
                                            min={1}
                                            max={10}
                                            values={[_min_bedrooms, _max_bedrooms]}
                                            disabled={!is_coordinator}
                                            onValuesUpdated={(value) => {
                                                handleUpdateBed(value);
                                                this.setModified();
                                            }}/>
                                    </div>
                                    <div className="top-bar-slider m-2">
                                        <p>
                                            <small>
                                                <i className="fa fa-bath"/>
                                                {' ' + _min_bathrooms + ' - ' + _max_bathrooms}
                                            </small>
                                        </p>

                                        <Rheostat
                                            min={1}
                                            max={10}
                                            values={[_min_bathrooms, _max_bathrooms]}
                                            disabled={!is_coordinator}
                                            onValuesUpdated={(value) => {
                                                handleUpdateBath(value);
                                                this.setModified();
                                            }}/>
                                    </div>
                                    <FormGroup style={{marginTop: '2rem'}}>
                                        <Label for="min_start">Lease Starts Between</Label>
                                        <Input type="select"
                                               name="min_lease_start"
                                               id="min_start"
                                               onChange={(e) => {
                                                   handleUpdateMinLeaseStart(e.target.value);
                                                   this.setModified();
                                               }}
                                               disabled={!is_coordinator}
                                               bsSize="sm"
                                               value={min_lease_start_month}
                                        >
                                            <option value={1}>January</option>
                                            <option value={2}>February</option>
                                            <option value={3}>March</option>
                                            <option value={4}>April</option>
                                            <option value={5}>May</option>
                                            <option value={6}>June</option>
                                            <option value={7}>July</option>
                                            <option value={8}>August</option>
                                            <option value={9}>September</option>
                                            <option value={10}>October</option>
                                            <option value={11}>November</option>
                                            <option value={12}>December</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="min_start">and</Label>
                                        <Input type="select"
                                               name="min_lease_start"
                                               id="min_start"
                                               onChange={(e) => {
                                                   handleUpdateMaxLeaseStart(e.target.value);
                                                   this.setModified();
                                               }}
                                               disabled={!is_coordinator}
                                               bsSize="sm"
                                               value={max_lease_start_month}
                                        >
                                            <option value={1}>January</option>
                                            <option value={2}>February</option>
                                            <option value={3}>March</option>
                                            <option value={4}>April</option>
                                            <option value={5}>May</option>
                                            <option value={6}>June</option>
                                            <option value={7}>July</option>
                                            <option value={8}>August</option>
                                            <option value={9}>September</option>
                                            <option value={10}>October</option>
                                            <option value={11}>November</option>
                                            <option value={12}>December</option>
                                        </Input>
                                    </FormGroup>
                                    <div className="center">
                                        <Button color="primary" disabled={this.state.isUpdating || !this.state.modified || !is_coordinator} onClick={() => {
                                            this.setState({isUpdating: true});
                                            handleSavePreferences(listing_preferences).then(() => {
                                                this.setState({isUpdating: false, modified: false});
                                                Alert.success("Updated your preferences!");
                                            });
                                        }}>
                                            <div style={{position: "relative"}}>
                                            <span style={{visibility: this.state.isUpdating ? 'hidden' : 'visible'}}>
                                                Save
                                            </span>
                                                <div className="animated fadeIn"
                                                     style={{position: 'absolute', left: 0, right: 0, top: 'calc(50% - 10px)', display: this.state.isUpdating ? 'inherit' : 'none'}}>
                                                    <i className="fa fa-spinner fa-pulse"></i>
                                                </div>
                                            </div>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={12} className="center">

                                </Col>
                            </Row>
                            <Tooltip placement="bottom" isOpen={this.state.showHelpTooltip} target="info_tooltip" toggle={() => this.setState({showHelpTooltip: !this.state.showHelpTooltip})}>
                                Whenever a new listing is added to PolyRents, we send notifications to groups with matching criteria. Set your preferences below to get relevant recommendations.
                            </Tooltip>
                        </div>
                    </CardBody>
                </Card>
            );
        } else {
            return (
                <Card className="pr-card">
                    <CardHeader tag="h4">Listing Recommendation Notifications</CardHeader>
                    <Loader isLoading spin/>
                </Card>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    listing_preferences: state.tenant.listing_preferences,
    is_coordinator: state.tenant.roommate_group.coordinator && state.tenant.roommate_group.coordinator.get_email === state.activeUser.email
});

const mapDispatchToProps = (dispatch) => ({
    handleUpdateRent(value) {
        return dispatch(setTenantPrefRent(value.values));
    },
    handleUpdateBed(value) {
        return dispatch(setTenantPrefBed(value.values));
    },
    handleUpdateBath(value) {
        return dispatch(setTenantPrefBath(value.values));
    },
    handleUpdateMinLeaseStart(value) {
        return dispatch(setMinLeaseMonth(value));
    },
    handleUpdateMaxLeaseStart(value) {
        return dispatch(setMaxLeaseMonth(value));
    },
    handleSavePreferences(preferences) {
        return dispatch(handleUpdateListingPreferences(preferences));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TenantGroupPreferences);



// WEBPACK FOOTER //
// ./src/containers/settings/TenantGroupPreferences.js